import React from "react"
import { cn } from "design_system/libs"
import TopicBadge from "@love-irish/resource-topic-badge"

export interface Topic {
  id?: string
  slug: string
  name?: string
  color?: string
  path?: string
}

export interface ItemTopic {
  id: string
  source?: string
  topic: Topic
}

export interface TopicListProps {
  /** Array of item topics (with nested topic object) */
  itemTopics?: ItemTopic[]
  /** Additional CSS classes for the container */
  className?: string
  /** Additional CSS classes for each badge */
  badgeClassName?: string
  /** Show at most this many topics, then a "+N more" chip so a long list doesn't overrun a card. Default 5;
   *  pass 0 (or Infinity) to show all. */
  max?: number
}

export const TopicList: React.FC<TopicListProps> = ({
  itemTopics,
  className,
  badgeClassName = "mr-2 mb-2",
  max = 5,
}) => {
  if (!itemTopics?.length) return null

  const shown = max > 0 ? itemTopics.slice(0, max) : itemTopics
  const overflow = itemTopics.length - shown.length

  return (
    <div className={cn("mt-6", className)}>
      {shown.map((itemTopic) => (
        <TopicBadge
          key={itemTopic.id}
          topic={itemTopic.topic}
          className={badgeClassName}
        />
      ))}
      {overflow > 0 && (
        <span
          className={cn(
            "inline-block align-middle text-xs text-muted-foreground",
            badgeClassName
          )}
          // The hidden topics' names, so the count is discoverable on hover.
          title={itemTopics
            .slice(shown.length)
            .map((it) => it.topic.name)
            .filter(Boolean)
            .join(", ")}
        >
          +{overflow} more
        </span>
      )}
    </div>
  )
}

export default TopicList
